import { sportOptions, type Sport } from "@teamna/shared";

/** The sport chips on Create business and on the business step: the shared list (`sportOptions`). */
export const SPORT_OPTIONS: Array<{ id: Sport; label: string }> = [...sportOptions];

/** The words a sport starts with, in one line (`labelPreviewLine` in `@teamna/shared`, also used by the phone). */
export { labelPreviewLine } from "@teamna/shared";
